






























import { Component } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';

@Component({ name: 'ScheduledFeesDeleteDialog' })
export default class extends SaascadaVueDialog {

    get feeName() {
        return ProductDetailsModule.currentScheduledFee.name;
    }

    async deleteFee() {
        await ProductDetailsModule.deleteScheduledFee();
        this.dialog = false;
    }

}
